const BASEURL = 'https://primarysourcemedia.com/wp-api/wp-json/wp/v2/';
const IMGURL = 'https://primarysourcemedia.com/wp-api/wp-json/wp/v2/'

// const BASEURL = 'http://localhost/primeSourchMedia/wp-json/wp/v2/';
// const IMGURL = 'http://localhost/primeSourchMedia/wp-json/wp/v2/'
export {BASEURL, IMGURL }